var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "msg-bell-msg-view" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.addDialog.view === "list",
              expression: "addDialog.view === 'list'"
            }
          ],
          staticClass: "main-content"
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-top": "10px" }
            },
            [
              _c(
                "div",
                { staticClass: "triggers" },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ScenarioName")))
                  ]),
                  _c("el-input", {
                    staticStyle: { width: "200px", margin: "0 10px" },
                    attrs: {
                      placeholder: _vm.$t("SeaExport.PleaseInputAKeyword")
                    },
                    on: {
                      input: function($event) {
                        return _vm.searchHandle()
                      }
                    },
                    model: {
                      value: _vm.pageInfo.jobNo,
                      callback: function($$v) {
                        _vm.$set(_vm.pageInfo, "jobNo", $$v)
                      },
                      expression: "pageInfo.jobNo"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.searchHandle }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.btnAdd } },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.btnCopy } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Copy")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.btnRemoveHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "flex-grow": "1" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "250721",
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "grid-options": _vm.gridOptions,
                  "side-bar": _vm.sideBarDefs
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "250722",
                  total: _vm.pageInfo.total,
                  page: _vm.pageInfo.pageNum,
                  limit: _vm.pageInfo.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.pageInfo, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.pageInfo, "pageSize", $event)
                  },
                  pagination: _vm.searchHandle
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.addDialog.visible,
            "close-on-click-modal": false,
            title: _vm.addDialog.title,
            width: "440px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.addDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "div",
                { staticClass: "filters" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { "label-width": "80px", "label-position": "left" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ScenarioName")
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "300px" },
                                attrs: { no: "taskName" },
                                model: {
                                  value: _vm.addDialog.form.taskName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addDialog.form,
                                      "taskName",
                                      $$v
                                    )
                                  },
                                  expression: "addDialog.form.taskName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_TaskScenario")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "300px" },
                                  model: {
                                    value: _vm.addDialog.form.taskScenario,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.addDialog.form,
                                        "taskScenario",
                                        $$v
                                      )
                                    },
                                    expression: "addDialog.form.taskScenario"
                                  }
                                },
                                _vm._l(
                                  _vm.SystemConstants.TASK_SCENARIO_LIST,
                                  function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: _vm.language
                                          ? item.chineseName
                                          : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          ),
                          _vm.addDialog.form.taskScenario !==
                          _vm.SystemConstants.TASK_SCENARIO_2.code
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_DataType")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "300px" },
                                      model: {
                                        value: _vm.addDialog.form.dataType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addDialog.form,
                                            "dataType",
                                            $$v
                                          )
                                        },
                                        expression: "addDialog.form.dataType"
                                      }
                                    },
                                    _vm._l(
                                      _vm.SystemConstants.DATA_TYPE_LIST,
                                      function(item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: _vm.language
                                              ? item.chineseName
                                              : item.englishName,
                                            value: item.code
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  no: "remarks",
                                  type: "textarea",
                                  rows: 3
                                },
                                model: {
                                  value: _vm.addDialog.form.remarks,
                                  callback: function($$v) {
                                    _vm.$set(_vm.addDialog.form, "remarks", $$v)
                                  },
                                  expression: "addDialog.form.remarks"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onNext } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Next")))]
              ),
              _c("el-button", { on: { click: _vm.onCancel } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
              ])
            ],
            1
          )
        ]
      ),
      _c("auto-config-detail", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.addDialog.view === "detail",
            expression: "addDialog.view === 'detail'"
          }
        ],
        ref: "autoConfigDetail",
        on: { refresh: _vm.searchHandle }
      }),
      _vm.logDialog.visible
        ? _c("task-log-dialog", {
            ref: "taskLogDialog",
            attrs: { visible: _vm.logDialog.visible, form: _vm.logDialog.form },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.logDialog, "visible", $event)
              },
              close: function($event) {
                _vm.logDialog.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }